// Import global utils
import { addParametersToURL } from '@automator/shared/utils/add-parameters-to-url';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// eslint-disable-next-line import/no-unresolved
import $ from 'jquery';

/**
 * Creates circle on the bottom right corner for users to send feedback
 */
export default class SendFeedback {
	// eslint-disable-next-line require-jsdoc
	constructor() {
		this.render();
	}

	/**
	 * Creates the elements
	 *
	 * @return {undefined}
	 */
	render() {
		const $container = $( `
			<div class="uap-report-bug">
				<a
					class="uap-report-bug__btn"

					uap-tooltip="${ escapeHTML( __( 'Send feedback', 'uncanny-automator' ) ) }"
					uap-tooltip-flow="left"

					target="_blank"
					href="${ addParametersToURL( 'https://automatorplugin.com/feedback/', this.utmBtnParameters ) }"
				>
					<span class="uap-report-bug__icon"></span>
				</a>
			</div>
		` );

		// Append to the body
		$( 'body' ).append( $container );
	}

	/**
	 * Returns the UTM parameters for the link that goes
	 * to automatorplugin.com for users to leave feedback
	 *
	 * @return {Object} UTM parameters
	 */
	get utmBtnParameters() {
		// Check version
		let version, utmSource;

		if ( ! UncannyAutomatorBackend._site.automator.is_pro_active ) {
			version = `Uncanny Automator ${ UncannyAutomator._site.automator.version }`;
			utmSource = 'uncanny_automator';
		} else {
			version = `Uncanny Automator Pro ${ UncannyAutomator._site.automator.version }`;
			utmSource = 'uncanny_automator_pro';
		}

		return {
			version: version,
			// eslint-disable-next-line camelcase
			utm_source: utmSource,
			// eslint-disable-next-line camelcase
			utm_medium: 'send_feedback',
			// eslint-disable-next-line camelcase
			utm_content: 'bulb_icon',
		};
	}
}
